export const OBSERVATION = 'Observation';
export const OBSERVATION_PLUS = 'ObservationPlus';
export const PUM_INPATIENT = 'PUM Inpatient';
export const PUM_OBSERVATION = 'PUM Observation';
export const INPATIENT = 'Inpatient';
export const INPATIENT_PLUS = 'InpatientPlus';

export const MEL_OPTIONS = [
  { label: 'Select', value: '', isHidden: true },
  { label: 'Select All', value: '' },
  { label: INPATIENT, value: INPATIENT },
  { label: PUM_INPATIENT, value: INPATIENT_PLUS },
  { label: OBSERVATION, value: OBSERVATION },
  { label: PUM_OBSERVATION, value: OBSERVATION_PLUS },
];
